import { generateKeyString } from "#src/utils/common";
import type {
  WrittenOnTheToast,
  InternalToastProps,
} from "../toasts/core/types";
import { useToastList } from "../toasts/core/useToastList";
import { Observable } from "#src/utils/observer";
import { NotificationBanner } from "./NotificationBanner";

const notificationObserver = new Observable();

/** Where we store notifications that requires user interaction. */
const NotificationBox = () => {
  const toasts = useToastList(notificationObserver);

  return (
    <div className="flex flex-col gap-2">
      {toasts.map((toast) => (
        <NotificationBanner
          key={`toast-${toast.id}`}
          toast={toast}
          observable={notificationObserver}
        />
      ))}
    </div>
  );
};

const createNotification = (newToast: WrittenOnTheToast) => {
  const internalToast: InternalToastProps = {
    ...newToast,
    id: generateKeyString(),
    status: "stable",
  };
  notificationObserver.notify(internalToast);
};

export { NotificationBox, createNotification };
